<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<ng-container *ngIf="!loading">
  <div class="cxs">

    <div class="cxs-nav">
      <button class="cxs-quit-btn" (click)="close()">
        <i class="fa-solid fa-arrow-left"></i>
        <span translate>Retour au parcours</span>
      </button>
    </div>

    <div class="cxs-card">

      <div class="cxs-icon">
        <i class="fa-solid fa-graduation-cap"></i>
      </div>

      <div class="cxs-cefrl">{{ state.cefrl }}</div>
      <div class="cxs-title">{{ state.name }}</div>

      <!-- Résultat déjà obtenu -->
      <div class="cxs-result mb-4" *ngIf="state.status === 'passed' || state.status === 'failed'">
        <div class="cxs-result-badge" [class.cxs-result-badge--passed]="state.status === 'passed'" [class.cxs-result-badge--failed]="state.status === 'failed'">
          <i class="fa-solid" [class.fa-circle-check]="state.status === 'passed'" [class.fa-circle-xmark]="state.status === 'failed'"></i>
          <span *ngIf="state.status === 'passed'" translate>Examen réussi</span>
          <span *ngIf="state.status === 'failed'" translate>Examen non validé</span>
        </div>
        <div class="cxs-result-score">
          <span translate>Score</span> : <strong>{{ state.bestScore }}%</strong>
        </div>
        <div class="cxs-result-date" *ngIf="state.lastDate">
          {{ state.lastDate | date:'dd/MM/yyyy' }}
        </div>
      </div>

      <!-- Tentative en cours -->
      <div class="cxs-in-progress mb-4" *ngIf="state.status === 'in_progress'">
        <i class="fa-solid fa-hourglass-half mr-2"></i>
        <span translate>Tu as une tentative en cours, tu peux la reprendre là où tu t'étais arrêté.e.</span>
      </div>

      <!-- Infos -->
      <div class="cxs-infos mb-4">
        <div class="cxs-info">
          <div class="cxs-info-value">{{ state.questionCount }}</div>
          <div class="cxs-info-label" translate>questions</div>
        </div>
        <div class="cxs-info">
          <div class="cxs-info-value">{{ state.successScore }}%</div>
          <div class="cxs-info-label" translate>pour réussir</div>
        </div>
      </div>

      <div class="cxs-notice mb-4" *ngIf="state.status === 'todo' || state.status === 'in_progress'">
        <i class="fa-solid fa-circle-info mr-1"></i>
        <span translate>Une question à la fois, sans retour en arrière ni correction pendant l'examen. Rater l'examen ne bloque pas la suite de ton parcours.</span>
      </div>

      <!-- Actions -->
      <div class="cxs-actions">
        <button class="cxs-btn cxs-btn-primary" *ngIf="state.status === 'todo'" (click)="start()" translate>
          Passer l'examen
        </button>
        <button class="cxs-btn cxs-btn-primary" *ngIf="state.status === 'in_progress'" (click)="start()" translate>
          Reprendre l'examen
        </button>
        <ng-container *ngIf="state.status === 'passed' || state.status === 'failed'">
          <button class="cxs-btn"
                  [class.cxs-btn-outline]="hasNextStep"
                  [class.cxs-btn-primary]="!hasNextStep"
                  (click)="viewResult()" translate>
            Voir la correction
          </button>
          <button class="cxs-btn cxs-btn-primary" *ngIf="hasNextStep" (click)="goToNextStep()">
            <span *ngIf="state.nextStep.type === 'section'" translate>Passer à la section suivante</span>
            <span *ngIf="state.nextStep.type !== 'section'" translate>Continuer le parcours</span>
            <i class="fa-solid fa-arrow-right ml-2"></i>
          </button>
        </ng-container>
      </div>

    </div>

  </div>
</ng-container>
